"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDistributionList = exports.fetchDistributionList = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/distribution/list");
const Actions = require("../../actions/distribution/list");
const AddressBookActions = require("../../actions/distribution/addressBook");
const WizardActions = require("../../actions/distribution/wizard");
const sok_types_1 = require("@caddigital/sok-types");
function fetchDistributionList(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_DISTRIBUTION_LIST_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/distribution/project/${request.payload.uuid}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(sok_types_1.Distribution.iDistribution)
            .decode(response);
        const act = validation.fold((e) => Actions.fetchDistributionListFailed((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchDistributionListSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchDistributionListFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchDistributionList = fetchDistributionList;
function deleteDistributionList(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_DISTRIBUTIONS_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/distribution/delete`,
        body: request.payload
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const actions = [
            Actions.deleteDistributionsSuccess()
        ];
        const state = store.value;
        if (state.project.currentProject.status === 'FETCHED') {
            actions.push(Actions.fetchDistributionListRequest(state.project.currentProject.project));
        }
        return (0, rxjs_1.merge)((0, rxjs_1.of)(...actions), (0, rxjs_1.of)(AddressBookActions.clearState()), (0, rxjs_1.of)(WizardActions.clearWizard()));
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteDistributionsFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.deleteDistributionList = deleteDistributionList;
//# sourceMappingURL=list.js.map